import RecreationGovClient from "../externalclients/RecreationGovClient";
import ParkOrderToR1SOrderConverter from "../helpers/ParkOrderToR1SOrderConverter";

//Performs steps to create a pending order with R1S and CCP
export default class OrderService {
  submitOrder(order) {
    //Two steps:
    // 1. Create Pending Order with R1S
    // 2. Prepare Payment with CCP
    let converter = new ParkOrderToR1SOrderConverter();
    let r1sOrder = converter.convert(order);
    let orderclone = JSON.parse(JSON.stringify(order));
    orderclone.RecGovOrder = r1sOrder;

    let client = new RecreationGovClient();
    return client
      .createPendingOrder(r1sOrder)
      .then(result => {
        orderclone.referenceNumber = result.reference_number;
        //TODO: Update once total_cost response is fixed
        orderclone.totalCost = result.total_cost / 100;
        orderclone.tokenInfo = {
          r1stoken: result.token
        };

        return result;
      })
      .then(result => {
        if (result && result.status && result.status == "500") {
          return result;
        }
        return client.preparePayment(orderclone).then(response => {
          return {
            referenceNumber: orderclone.referenceNumber,
            totalCost: "$" + result.total_cost / 100,
            r1stoken: result.token,
            paymentInfo: response
          };
        });
      });
  }

  purchase(order) {
    //May not be needed
    let client = new RecreationGovClient();
    return client.purchase(order);
  }

  getOrderStatus(paymentToken, r1stoken, referenceNumber) {
    let client = new RecreationGovClient();
    let requestData = {
      paymentToken: paymentToken,
      r1stoken: r1stoken,
      referenceNumber: referenceNumber
    };
    return client.getOrderStatus(requestData);
  }
}
